import * as Accordion from '@radix-ui/react-accordion';
import React from 'react';
import { Stack } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  title: string | React.ReactNode;
}

const BoxAccordion = ({ title, children }: React.PropsWithChildren<Props>) => {
  return (
    <Styled.AccordionRoot
      type="single"
      defaultValue={children ? 'item-1' : ''}
      collapsible
    >
      <Styled.AccordionItem value="item-1">
        <Accordion.Header>
          <Styled.AccordionTrigger className={children ? '' : 'nothing'}>
            <Stack justifyContent="space-between" alignItems="center" gap={8}>
              <div>{title}</div>
              <Styled.ChevronIcon icon="ph:caret-up" size={19} />
            </Stack>
          </Styled.AccordionTrigger>
        </Accordion.Header>
        <Styled.AccordionContent>{children}</Styled.AccordionContent>
      </Styled.AccordionItem>
    </Styled.AccordionRoot>
  );
};

export default BoxAccordion;
